<template lang="pug">
.mno-buttons(:class="getClass(isRightMenu)")
  button.reset-btn.button(v-if="hideLinkBtn" @click.stop="openForm('link')" :disabled="disabledParam") Привязка МНО и Источников образования отходов
  button.reset-btn.button(v-if="hideCreateDeleteBtn" @click.stop="openForm('create')" :disabled="disabledParam") {{getButtonText('buttonMnoCreateText')}}
  button.reset-btn.button.button_warning(v-if="hideCreateDeleteBtn" @click.stop="openForm('deleted')" :disabled="disabledParam") {{getButtonText('buttonMnoDeleteText')}}

  .modal-container.filter-popup(v-if="isOpenForm" :class="getClass()")
    .modal-header
      .title Введите параметры:
      span (не обязательно)
      button.reset-btn.close(@click.prevent="closeForm")
    .modal-body
      .item-block
        label.label Район:
        select.select(@change="changeSelect" v-model="regionMno" )
          option(v-for="item in regionsList" :key="item.id" :value="item.value") {{item.label}}
      .item-block(v-if="!isDeleted" )
        label.label Радиус (м):
        input.input(type='number' name="radius-mno" min="0" v-model="radiusMno" )
    .modal-bottom
      button.reset-btn.button.sucess(type="submit" @click.prevent="sendForm") Выполнить

  .modal-container.filter-popup.tooltip__body(v-if="isProgressBar" :class="getClass()")
    .tooltip__error(v-if="hasErrorCapacity") Ошибка при выполненнии
    div(v-if="statusProgress").tooltip__body-bar
      div(v-if="jobTypeTitle") Операция: {{ jobTypeTitle }}
      div.message
        span Статус:
        span(:class="messageClass") {{statusProgress}}
      .tooltip__body-loader(:class="isRightMenu ? 'center' : ''")
        .loader-dot.first-dot
        .loader-dot.second-dot
        .loader-dot.third-dot
      div Выполняется: {{loadingPercent}}%
      progress(max="100" v-model="loadingPercent" :value="loadingPercent")
</template>

<script>
import { msn, garbage, core } from '@/api/api-endpoints'
import textMixin from '@/mixins/text-mixin'
import hasMixin from '@/mixins/has-mixin'
import { REGION_CONFIG } from '@/config/regions'

export default {
  name: 'mno-buttons',
  mixins: [textMixin, hasMixin],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    isRightMenu: {
      type: Boolean,
      default: () => false,
    },
    hideLinkBtn: {
      type: Boolean,
      default: () => true,
    },
    hideCreateDeleteBtn: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      isOpenForm: false,
      regionMno: '',
      radiusMno: 0,
      isLink: false,
      isCreate: false,
      isDeleted: false,
      hasErrorCapacity: false,
      isProgressBar: false,
      jobId: null,
      isDisabled: false,
      disabledParam: false,
      loadingPercent: 0,
      statusProgress: '',
      messageClass: '',
      jobTypeTitle: '',
      progressTimeout: null,
    }
  },
  computed: {
    regionsList() {
      let options = []
      this.$props.options.forEach(({ id, name }) => {
        options.push({
          id: id,
          value: name,
          label: name,
        })
      })
      const allIndexElem = options.findIndex(({ id }) => id === 'all')
      if (allIndexElem || allIndexElem === 0) {
        options[allIndexElem].id = null
        options[allIndexElem].value = 'Все муниципальные районы'
        options[allIndexElem].label = 'Все муниципальные районы'
      }
      return options
    },
  },
  methods: {
    getButtonText(str) {
      return REGION_CONFIG.texts[str]
    },
    openForm(str) {
      this.checkActiveJob()
      this.isOpenForm = false
      this.resetClass()
      this.resetData()

      switch (str) {
        case 'link':
          this.isLink = 'is-link'
          break
        case 'create':
          this.isCreate = 'is-create'
          break
        case 'deleted':
          this.isDeleted = 'is-deleted'
          break
      }

      this.isOpenForm = true
    },
    closeForm() {
      this.resetData()
      this.resetClass()
    },
    resetData() {
      this.isOpenForm = false
      this.regionMno = 'Все муниципальные районы'
      this.radiusMno = 200
    },
    resetClass() {
      this.isLink = ''
      this.isCreate = ''
      this.isDeleted = ''
    },
    resetProgress() {
      this.isDisabled = false
      this.disabledParam = false
      this.statusProgress = ''
      this.jobTypeTitle = ''
      this.loadingPercent = 0
      this.isProgressBar = false
      this.isOpenForm = false
      this.messageClass = ''
    },
    async sendForm() {
      let urlCurrent = {}
      let dispatchType = ''
      if (this.isCreate) {
        urlCurrent = {
          data: {
            radius: this.radiusMno,
            area:
              this.regionMno === 'Все муниципальные районы'
                ? ''
                : this.regionMno,
          },
          url: msn.postMsnModeling(),
        }
        dispatchType = 'createModel'
      } else if (this.isLink) {
        urlCurrent = {
          data: {
            radius: this.radiusMno,
            area:
              this.regionMno === 'Все муниципальные районы'
                ? ''
                : this.regionMno,
          },
          url: garbage.postGarbageSourceLinkMsn(),
        }
        dispatchType = 'createModel'
      } else if (this.isDeleted) {
        urlCurrent = {
          data: {
            area:
              this.regionMno === 'Все муниципальные районы'
                ? ''
                : this.regionMno,
          },
          url: msn.deleteMsnModeling(),
        }
        dispatchType = 'deleteModel'
      }

      try {
        await this.$store
          .dispatch(dispatchType, urlCurrent)
          .then((res) => {
            if (this.isDeleted) return
            if (res.data.job_id) {
              this.jobId = res.data.job_id
              this.isProgressBar = true
              this.isDisabled = true
              this.disabledParam = true
              this.$e.successBox('Постановка задачи в очередь')
            }
          })
          .then(() => {
            if (this.isDeleted) {
              this.$e.successBox('Удаление модельных МСН прошло успешно')
              this.doProgress()
            } else {
              this.doProgress(this.jobId)
            }
          })
      } catch (er) {
        this.resetClass()
        this.$e.errorBox(er)
      } finally {
        if (this.isDeleted) {
          this.resetClass()
        }
        this.resetData()
      }
    },

    doProgress(id) {
      this.isProgressBar = true
      const status = {
        waiting: 'ожидающий',
        in_progress: 'в ходе выполнения',
        successful: 'успешный',
        failed: 'неуспешный',
      }
      if (!id) {
        this.$emit('doProgress', this.isLink)
        return
      }
      try {
        this.$store
          .dispatch('updateUrlEndpoint', {
            url: core.getCoreJobProgressByJobId(id),
          })
          .then((res) => {
            if (res.data) {
              this.loadingPercent = res.data.progress
              this.statusProgress = status[res.data.status]
            }
            if (
              res.data.status === 'failed' ||
              res.data.status === 'successful'
            ) {
              this.$emit('doProgress', id, this.isLink)
              this.messageClass = res.data.status
              setTimeout(() => {
                this.resetProgress()
                this.resetData()
                this.resetClass()
              }, 10000)
              return
            } else if (res.data.status === 'in_progress') {
              this.progressTimeout = setTimeout(() => {
                this.doProgress(this.jobId)
              }, 3000)
            } else {
              this.progressTimeout = setTimeout(() => {
                this.doProgress(this.jobId)
              }, 5000)
            }
          })
      } catch (erResponse) {
        this.resetProgress()
        this.resetClass()
        this.resetData()
        this.$e.errorBox(erResponse)
        return {}
      }
    },
    changeSelect(event) {
      this.regionMno = event.target.value
    },
    getClass(e) {
      if (this.isRightMenu && e) {
        return 'right-menu'
      }
      if (this.isRightMenu) {
        return `center`
      }
      if (this.isLink) {
        return `is-link`
      }
      if (this.isCreate) {
        return `is-create`
      }
      if (this.isDeleted) {
        return `is-deleted`
      }
    },
    checkActiveJob() {
      try {
        this.$store
          .dispatch('updateUrlEndpoint', {
            url: core.getCoreActiveJob(),
          })
          .then((response) => {
            if (response.data.length) {
              response.data.map((item) => {
                let jobTypeArr = item.job_type.split('\\')
                let jobType = jobTypeArr[jobTypeArr.length - 1]
                if (
                  ['MsnModelingJob', 'GarbageSourceLinkMsnJob'].includes(
                    jobType
                  )
                ) {
                  this.jobTypeTitle =
                    jobType === 'MsnModelingJob'
                      ? `${this.getButtonText('buttonMnoCreateText')}`
                      : 'Привязка МНО и Источников образования отходов'
                  this.disabledParam = true
                  this.jobId = item.job_id
                  this.doProgress(this.jobId)
                  this.resetData()
                }
              })
            }
          })
      } catch (erResponse) {
        this.resetProgress()
        this.resetClass()
        this.resetData()
        this.$e.errorBox(erResponse)
        return {}
      }
    },
  },
  mounted() {
    this.checkActiveJob()
  },
  beforeDestroy() {
    clearTimeout(this.progressTimeout)
  },
}
</script>

<style scoped lang="scss">
.mno-buttons {
  display: flex;
  align-items: center;
  gap: 10px;

  &.right-menu {
    flex-direction: row;
    .button {
      width: 50%;

      &.sucess {
        width: 100%;
      }
    }
  }
}

.modal {
  &-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    top: 165px;
    max-height: fit-content;
    width: 550px;
    right: 30px;
    position: absolute;

    &.is-link {
      right: 40%;
    }

    &.is-create {
      right: 20%;
    }

    &.is-deleted {
      right: 30px;
    }
    &.center {
      width: 345px;
      right: 0;
      top: 45%;
    }
  }

  &-body {
    display: flex;
    gap: 10px;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    width: 100%;

    .item-block {
      display: flex;
      gap: 10px;
      align-items: baseline;
      justify-content: space-between;
      width: 100%;

      .label {
        width: 120px;
      }
    }
  }
}
.tooltip__body-bar {
  width: 100%;
  progress {
    width: 100%;
  }
}
.message {
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 5px;
  margin-bottom: 5px;

  .failed {
    color: #ee3535;
  }
  .successful {
    color: #72b429;
  }
}
.tooltip__body-loader {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  height: 30px;
  &.center {
    top: 40px;
  }
}
.loader-dot {
  border-radius: 50%;
  background-color: #4086f7;
  width: 15px;
  height: 15px;
  margin-right: 10px;
  animation: dot-animate 2s ease-in-out infinite;
}
.second-dot {
  animation-delay: 0.4s;
}
.third-dot {
  animation-delay: 0.8s;
}

@keyframes dot-animate {
  50% {
    opacity: 0;
    transform: scale(0.7) translateY(10px);
  }
  100% {
    background-color: rgba(64, 134, 247, 0.3);
  }
}
</style>
